import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getBlueYonderUpcharge = unaryRpc({
  name: "getBlueYonderUpcharge" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    hasIntegration: z.boolean(),
    upcharge: z.number().optional(),
  }),
});

export const updateBlueYonderUpcharge = unaryRpc({
  name: "updateBlueYonderUpcharge" as const,
  input: z.object({ teamId: z.string(), upcharge: z.number() }),
  output: z.object({
    hasIntegration: z.boolean(),
    upcharge: z.number().optional(),
  }),
});
